/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1218
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.default = function () {
  undefined
}
